/**
 * UnsavedChangesDialog - Dialog for warning about unsaved changes when closing
 */
import Dialog from '../../../../../organisms/dialogs/Dialog/Dialog';
import React from 'react';
import useUnsavedChangesDialog from './useUnsavedChangesDialog';

type UnsavedChangesDialogProps = {
  isOpen: boolean;
  onClose: () => void;
  onDiscard: () => void;
  onSaveAndClose: () => void;
  isSaving?: boolean;
};

function UnsavedChangesDialog({ isOpen, onClose, onDiscard, onSaveAndClose, isSaving = false }: UnsavedChangesDialogProps): JSX.Element {
  const { t, title, warningText, discardButtonText, saveButtonText, cancelButtonText } = useUnsavedChangesDialog();

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      size="m"
      buttonTextCancel={cancelButtonText}
      buttonTextSuccess={saveButtonText}
      onCancel={onClose}
      onSuccess={onSaveAndClose}
      isLoading={isSaving}
      customFooterLeft={
        <button type="button" className="button button--inline button--transparent-primary button--small" onClick={onDiscard} disabled={isSaving}>
          {discardButtonText}
        </button>
      }
    >
      <div className="unsaved-changes-dialog">
        <div className="unsaved-changes-dialog__warning">
          <p>{warningText}</p>
        </div>
      </div>
    </Dialog>
  );
}

export default UnsavedChangesDialog;
